// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__254ZL","imageUploader":"EGiftCard_imageUploader__1-beF"};